import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";

const DeleteSceneModal = ({
  isOpen,
  onClose,
  isDeleting,
  handleDeleteScene,
  sceneId,
  sceneTitle,
}) => {
  return (
    <Modal
      closeOnEsc={!isDeleting}
      closeOnOverlayClick={!isDeleting}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete &quot;{sceneTitle}&quot;</ModalHeader>
        <ModalBody>
          <Text>
            Are you sure you want to delete this scene? This action cannot be
            undone.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button
            isDisabled={isDeleting}
            mr={3}
            onClick={onClose}
            variant="ghost"
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            isLoading={isDeleting}
            onClick={() => handleDeleteScene(sceneId)}
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteSceneModal;
